import store from "../store/store";
import { configurationSelector } from "../store/selectors/selectors";
import { APIConnector, GenericServices, GenericServicesV2 } from "@green24/npm-javascript-utils";

let connector = new APIConnector(
	() => {
		return localStorage.getItem("api") || configurationSelector.selectData(store.getState())?.apiURL},
	() => configurationSelector.selectData(store.getState())?.token,
);

export class CubeSaveGenericServices extends GenericServices {
	constructor(rootURL, receiveProcessor, uploadProcessor) {
		super(connector, rootURL, receiveProcessor, uploadProcessor);
	}
}

export class CubeSaveGenericServicesV2 extends GenericServicesV2 {
	constructor(rootURL, options) {
		super(connector, rootURL, options);
	}

	getCreateUrl() {
		return this.url + '/';
	}
}
